import { ResponseUserData } from "app/main/admin/models/user.model";
import { ResponseCompany, ResponseCompanyBranch } from "./company-setting.model";
import { UserData } from "./user-data";

export class GlobalConfiguration {
    public currentUser:ResponseUserData=new ResponseUserData();
    public companyBranchSetting:ResponseCompanyBranch=new  ResponseCompanyBranch();
    public defaultBranchSetting:ResponseCompanyBranch=new  ResponseCompanyBranch();
    public companySetting:ResponseCompany=new  ResponseCompany();
    // EFFECTIVE Robert availability = global kill-switch (RobertIntegration:Enabled) AND the company toggle,
    // resolved once at login from GET /robert/status. PM-facing Robert UI gates on this (not the raw company
    // toggle) so it stays hidden while the feature ships dark even if a company admin flips its toggle on.
    public robertEnabled: boolean = false;

    /**
     * App-wide gate for the XML e-invoicing (Peppol) feature. Resolved from the default branch's
     * per-branch CompanyBranchFinance.EInvoicingEnabled flag, loaded into companyBranchSetting at
     * login. Every XML/Peppol UI surface (Export XML row actions + bulk buttons, the e-Invoicing
     * settings fields, client e-invoice fields, per-invoice VAT-category/exemption/buyer-reference
     * fields, the Unit UN/CEFACT code) gates on this. Default off until an admin enables it on the branch.
     */
    get eInvoicingEnabled(): boolean {
        return !!this.companyBranchSetting?.companyBranchFinanceData?.eInvoicingEnabled;
    }
}